<template>
  <div id="app">
    <transition name="overflow-fade">
      <div
        v-if="$root.ready && overflow"
        class="ready-overflow"
        @click="openWebsite()"
      >
        <div class="text-center w-100">
          <div class="title">Undangan {{ title }}</div>
          <span>from</span>
          <div class="mb-5 name">
            {{ wedding.man.surname }} & {{ wedding.woman.surname }}
          </div>

          <button
            class="text-uppercase btn btn-outline-primary"
            @click="openWebsite()"
          >
            Buka Undangan
          </button>
        </div>
      </div>
    </transition>

    <AGWAudio
      :file="music.file"
      :loop="music.loop"
      :autoplay="music.autoplay"
      ref="audio"
    />
    <AGWHero
      overlay
      :images="backgrounds"
      ref="hero"
      parallax
      target="#intro"
    />

    <div
      class="bg-white agw-content"
      :style="{ 'margin-top': `${$root.hero.height}px` }"
    >
      <AGWIntro id="intro" />

      <AGWPawiwahan id="pawiwahan" class="bg-blue-light py-5" />
      <AGWMepandes id="mepandes" class="pad-y-60" :mepandes="mepandes" />

      <AGWCounter
        id="counter"
        class="pad-y-60"
        :background="background"
        :date="time.start"
      />
      <AGWGallery id="gallery" class="py-5" />
      <AGWMap
        :height="450"
        :url="map"
        :directionUrl="direction"
        :location="location"
        id="map"
      />
    </div>

    <div class="agw-content" style="background: transparent">
      <Himbauan />
      <attendance id="attendance" class="pad-y-60"></attendance>
    </div>

    <FooterCeremonyku ref="footer" />

    <transition name="slide-fade">
      <guest-box :floating="true" v-if="$root.scroll.Y > $root.hero.height" />
    </transition>

    <div class="snackbar" v-if="sw.updateExists">
      New version available!
      <button @click="refreshApp" class="btn">REFRESH</button>
    </div>
  </div>
</template>

<script>
const ImageHero1 =
  "https://ik.imagekit.io/ceremonyku/reska-yeni/MON_3273.jpg?tr=w-800";
const ImageHero2 =
  "https://ik.imagekit.io/ceremonyku/reska-yeni/MON_3215.jpg?tr=w-800";
const ImageHero3 =
  "https://ik.imagekit.io/ceremonyku/reska-yeni/MON_4218.jpg?tr=w-800";

import Audio from "@/assets/audio/best-part-of-me.mp3";

import AGWHero from "@/components/Hero/HeroTwo";
import AGWIntro from "@/components/Intro";
import AGWPawiwahan from "@/components/Pawiwahan";
import AGWMepandes from "@/components/Mepandes";
import AGWCounter from "@/components/Counter";
import AGWGallery from "@/components/Gallery/GalleryOne";
import AGWMap from "@/components/Maps";
import AGWAudio from "@/components/Audio";
import GuestBox from "@/components/GuestBox";
import Attendance from "@/components/Attendance";
import Himbauan from "./components/Himbauan.vue";
import FooterCeremonyku from "@/components/Footer/Ceremonyku";

import { setInterval } from "timers";

const SESSION = [
  ["2021-06-14 15:00", "21.00"],
  ["2021-06-14 15:00", "18.30"],
  ["2021-06-14 18:30", "21.00"]
];

export default {
  name: "app",
  components: {
    AGWHero,
    AGWIntro,
    AGWPawiwahan,
    AGWMepandes,
    AGWCounter,
    AGWGallery,
    AGWMap,
    AGWAudio,
    GuestBox,
    Attendance,
    Himbauan,
    FooterCeremonyku,
  },
  data() {
    return {
      title: "Pawiwahan",
      backgrounds: [ImageHero1, ImageHero2, ImageHero3],
      bgActive: 0,
      dividerHeight: 0,
      overflow: true,
      location: "Jl. Nangka Selatan No. 22 Br. Tainsiat, Denpasar",
      map:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d493.0576489266143!2d115.2178737166671!3d-8.647610855643808!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOMKwMzgnNTEuNSJTIDExNcKwMTMnMDQuNSJF!5e0!3m2!1sen!2sid!4v1620526810701!5m2!1sen!2sid",
      direction:
        "https://www.google.co.id/maps/dir//-8.647636,115.217925/@-8.6476109,115.2178737,20z/data=!4m11!1m8!3m7!1s0x0:0x0!2zOMKwMzgnNTEuNSJTIDExNcKwMTMnMDQuNSJF!3b1!7e2!8m2!3d-8.6476358!4d115.2179247!4m1!3e0",
      time: {
        start: this.$moment("2021-06-14 15:00"),
        end: "21:00",
      },
      wedding: {
        man: {
          name: " I Gede Wibawa Reska Putra, S.E., M.M., BKP",
          surname: "Reska",
          parents: "I Made Redana., S.Sos & Kadek Ayu Putriyani AS., S.E",
          description: "Putra pertama",
          address: "Br. Tainsiat, Dangin Puri Kaja, Denpasar",
          photo:
            "https://ik.imagekit.io/ceremonyku/reska-yeni/IMG_9818.jpg?tr=w-667,h-836,fo-custom,cm-extract",
        },
        woman: {
          name: "Ni Ketut Yani Indrawati., S.Ak",
          surname: "Yani",
          parents: "I Made Dana & Netty Sumiati",
          address: "Br. Belusung, Peguyangan Kaja, Denpasar",
          description: "Putri keempat",
          photo:
            "https://ik.imagekit.io/ceremonyku/reska-yeni/IMG_9808.jpg?tr=w-667,h-835,fo-custom,cm-extract",
        },
      },
      mepandes: [
        // {
        //   name: 'I Gusti Ngurah Agung Teguh Aksama Putra',
        //   // image: 'https://ik.imagekit.io/ceremonyku/iyan-tini/SKP_4414e_XA6Xqi5UR_LiP.jpg?tr=w-671,h-671,fo-custom,cm-extract'
        // },
      ],
      gallery: [],
      music: {
        file: Audio,
        autoplay: true,
        loop: true,
      },
      sw: {
        refreshing: false,
        registration: null,
        updateExists: false,
      },
    };
  },
  computed: {
    background() {
      return this.backgrounds[this.bgActive];
    },
  },
  mounted() {
    const url = new URLSearchParams(window.location.search);
    const [start, end] = SESSION[(Number(url.get("sesi")) || 1) - 1] || SESSION[0];

    this.time.start = this.$moment(start);
    this.time.end = end;

    this.dividerHeight = `calc(100vh - ${this.$refs.footer.offsetHeight}px)`;
    setInterval(() => {
      let active = this.bgActive + 1;
      if (active >= this.backgrounds.length) {
        active = 0;
      }

      this.bgActive = active;
    }, 5000);
  },
  created() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (this.sw.refreshing) return;
        this.sw.refreshing = true;
        window.location.reload();
      });
    }
  },
  methods: {
    showRefreshUI(e) {
      this.sw.registration = e.detail;
      this.sw.updateExists = true;
    },
    refreshApp() {
      this.sw.updateExists = false;
      if (!this.sw.registration || !this.sw.registration.waiting) {
        return;
      }
      this.sw.registration.waiting.postMessage("skipWaiting");
    },
    openWebsite() {
      this.overflow = false;
      document.querySelector("#loading").classList.remove("active");
      if (this.$refs.audio) this.$refs.audio.play();
    },
  },
};
</script>

<style lang="scss" scoped>
.overflow-fade-enter-active {
  transition: all 1s ease;
}
.overflow-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.overflow-fade-enter,
.overflow-fade-leave-to {
  opacity: 0;
}
</style>
